<template xmlns:v-slot="http://www.w3.org/1999/XSL/Transform">
	<div :key="keyValue" class="read-only-offer-basic-section scope-offer">
		<egranty-section-divider
			text="Zakres oferty"
			icon="place"
			aria-label="label for icon"
			:show-print-info="showPrintInfo"
		></egranty-section-divider>
		<br>
		<v-flex xs12 sm6 d-flex>
			<v-autocomplete
				class="ml-3"
				:disabled="readonly"
				v-model="mainCountryName"
				:items="countries"
				item-text="name"
				item-value="name"
				label="Główny kraj"
				aria-label="main country"
				for="priority-tree-select-main-country"
				id="priority-tree-select-main-country"
			></v-autocomplete>
		</v-flex>
		<div>
			<offer-button
				text="Edytuj wybór priorytetów"
				icon="edit"
			></offer-button>
		</div>
		<v-treeview
			class="ma-3 ml-4 priority-tree-tree-view"
			:key="keyValue"
			v-model="tree"
			:active.sync="active"
			:items="tasks"
			:open-all="true"
			selectable
			:open.sync="open"
			item-key="uniqueName"
			:return-object=true
			aria-label="label for text"
		>
			<template v-slot:prepend="{ item }" >
				<v-icon>  label</v-icon>
			</template>
		</v-treeview>
		<br>
			<div class="ml-3 mr-3" 
			>
				<h2>Priorytet: {{priorityOptions[0].name}}</h2>
				<v-select
					:disabled="true"
					:key="keyValue"
					:items="priorityOptions[0].options"
					multiple
					item-text="name"
					item-value="id"
					aria-label="areas"
					label="Cele ogólne / rezultaty, których dotyczy oferta"
					for="priority-tree-areas"
				></v-select>
			</div>
		<v-flex xs12 sm6 d-flex>
			<v-autocomplete class="ml-3 mt-4"
				v-if="manyAccreditationCountries"
				:disabled="readonly"
				v-model="data.extraCountries"
				:items="extraCountries"
				item-text="name"
				item-value="id"
				label="Dodatkowe kraje"
			></v-autocomplete>
		</v-flex>

		<egranty-validation-error
			:error="error"
		></egranty-validation-error>
	</div>

</template>

<script>
	import OfferButton from "@/view/logged/offer/components/OfferButton";
	import EgrantySectionDivider from "../../../genericComponents/EgrantySectionDivider";
	import EgrantyValidationError from "../../../genericComponents/EgrantyValidationError";

	export default {
		name: "PriorityTreeEmpty",
		components: {EgrantyValidationError, EgrantySectionDivider, OfferButton},

		computed: {},
		methods: {

			startEdit() {
				this.error = "";
				this.tasks = this.tasksForPriorities.sort(function(a, b) {
          return a.orderId - b.orderId;
        });
				this.keyValue++;
				this.treeLoaded = true;
			},



			updateExtraCountries(val) {
				this.data.extraCountries = [];
				this.extraCountries = this.countries.filter(x => x.name !== val);
			},

			updatePriorityOptions() {

			},

			refresh() {
				if (this.contestId === undefined) {
					return;
				}
					//przykładowe kraje
					this.countries = [{"name":"Kraj","id":1},{"name":"Kraj","id":2}];

			},

			setMainCountryName() {
				if (this.data.mainCountryId !== null) {
					let country = this.countries.find(x => x.id === this.data.mainCountryId);
					this.mainCountryName = country !== undefined ? country.name : undefined;
					this.extraCountries = this.countries.filter(x => x.name !== this.mainCountryName);
				}
			},
		},

		watch: {
			value: {
				immediate: true,
				handler(val) {
					this.active = val.selected;
					this.data = val;
					this.selected = val.selected;
					this.setMainCountryName();
					this.dataFromServerLoaded = true;
				},
			},

		},


		data() {
			return {
				error: "",
				dataFromServerLoaded: false,
				treeLoaded: false,
				tree: [],
				activeTree: [],
				tasks: [],
				tasksForPriorities: [],
				selected: [],
				open: [],
				keyValue: 0,
				active: [],
				left: 0,
				countries: [],
				extraCountries: [],
				data: {
					mainCountryId: null,
					selected: {},
					extraCountries: [],
				},
				priorityOptions: [{"name":"","id":1,"options":[{"name":"obszar1","id":2},{"name":"obszar2","id":3}]}],
				mainCountryName: "",
			};
		},
		mounted() {
			this.refresh();
		},

		props: {
			value: {
				type: Object,

			},
			readonly: {type: Boolean, default: false},
			manyAccreditationCountries: {type: Boolean, default: false},
			manyTasks: {},
			manyPriorities: {},
			manyAreas: {},
			contestId: null,
			showPrintInfo: {
				type: Boolean, default: false
			}
		},
	};

</script>

<style>

	.priority-tree-tree-view .v-treeview-node__label {
		word-wrap: break-word;
		width: 100%;
	}

	.priority-tree-tree-view .v-treeview-node__content {
		max-width: 90%;
	}

	.priority-tree-tree-view .v-icon {
		display: block;
	}
</style>
